import createSaga from './createSaga'
import listSaga from './listSaga'
import deleteSaga from './deleteSaga'
import editSaga from './editSaga'
import creartePublicRegistry from './createPublicRegistry'
import editPublicRegistry from './editPublicRegistry'
import staticEnums from './staticEnumsSaga'

const labelTagSaga = [
    createSaga(),
    editSaga(),
    listSaga(),
    deleteSaga(),
    editPublicRegistry(),
    creartePublicRegistry(),
    staticEnums()
]

export default labelTagSaga
